module.exports = __webpack_public_path__ + "img/routemap001.b3b02b6f.png";